import { requestBenchmarkByGroup } from '@/service/benchmark'

const initialState = () => ({
  isLoading: false,
  benchmark: undefined,
})

const state = initialState()

const getters = {
  isLoading: state => state.isLoading,
  benchmark: state => state.benchmark.benchmark,
}

const mutations = {
  setBenchmark(state, benchmark) {
    state.benchmark = benchmark
  },
  startLoadingBenchmark(state) {
    state.isLoading = true
  },
  stopLoadingBenchmark(state) {
    state.isLoading = false
  },
}

const actions = {
  getBenchmarkByGroup({ commit }, groupId) {
    commit('startLoadingBenchmark')
    return requestBenchmarkByGroup(groupId).then(benchmark => {
      commit('stopLoadingBenchmark')
      commit('setBenchmark', benchmark)
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
